(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ea-card-swatch-row"] && !Shopify.designMode) return;
  try {
    // A swatch button (.ea-swatch-row__pick) shows its variant's photo on the card, the same way Horizon's
  // #updateVariantImages does, and points the card's price and links to that variant.
  // Listens on the window in the capture phase, before Horizon's product card, which would otherwise write the card's
  // position into the address for a click on a link inside the card.
  window.addEventListener('click', (event) => {
    const pick = event.target instanceof Element ? event.target.closest('.ea-swatch-row__pick') : null;
    const card = pick?.closest('product-card');
    if (!pick || !card) return;
    // A scent swatch is a link to its page (for search engines): a plain click stays on the card,
    // Ctrl/Cmd-click, Shift-click or the middle button still open the page.
    if (pick.tagName === 'A') {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      event.stopPropagation();
    }

    const { mediaId, url, price, soon, soonWhen, soonImage, color, imageSrc, imageSrcset, imageAlt, cardTitle } = pick.dataset;
    const slideshow = card.querySelector('slideshow-component');
    if (slideshow && mediaId) {
      for (const slide of slideshow.querySelectorAll('slideshow-slide[variant-image]')) {
        slide.hidden = slide.getAttribute('slide-id') !== mediaId;
      }
      slideshow.select({ id: mediaId }, undefined, { animate: false });
    }

    // A sister page (bath bomb scent) is another product: its main photo takes the place of the card's first photo,
    // and its name the card's title.
    if (imageSrc) {
      const first = card.querySelector('slideshow-slide');
      const image = first?.querySelector('img') ?? card.querySelector('.card-gallery img');
      if (image) {
        image.srcset = imageSrcset || '';
        image.src = imageSrc;
        image.alt = imageAlt || '';
      }
      const firstId = first?.getAttribute('slide-id');
      if (slideshow && firstId) slideshow.select({ id: firstId }, undefined, { animate: false });
    }
    const titleElement = card.querySelector('[ref="productTitleLink"] p');
    if (titleElement && cardTitle) titleElement.textContent = cardTitle;

    // A "coming soon" colour has no photo yet: a panel in its swatch colour covers the card photo instead.
    card.querySelector('.ea-card-soon')?.remove();
    const gallery = card.querySelector('.card-gallery');
    if (soon !== undefined && gallery) {
      const panel = document.createElement('div');
      panel.className = mediaId ? 'ea-card-soon ea-card-soon--badge' : 'ea-card-soon';
      if (soonImage) {
        // the real photo of the colour, pale, with "Coming soon" big in the middle (Anu, 29 Oct 2026)
        panel.className = 'ea-card-soon ea-card-soon--photo';
        panel.style.backgroundImage = `url("${soonImage}")`;
      } else if (!mediaId && color) panel.style.background = color;
      const name = document.createElement('span');
      name.className = 'ea-card-soon__name';
      name.textContent = soon;
      const text = document.createElement('strong');
      text.className = 'ea-card-soon__text';
      text.textContent = 'Coming soon';
      panel.append(name, text);
      // the month under it, e.g. "Nov 2026" (3 Nov 2026)
      if (soonWhen) {
        const when = document.createElement('span');
        when.className = 'ea-card-soon__when';
        when.textContent = soonWhen;
        panel.append(when);
      }
      gallery.append(panel);
    }

    for (const link of card.querySelectorAll('[ref="productCardLink"], [ref="cardGalleryLink"], [ref="productTitleLink"]')) {
      link.setAttribute('href', url);
    }
    const priceElement = card.querySelector('product-price .price');
    if (priceElement && price) priceElement.textContent = price;

    for (const other of card.querySelectorAll('.ea-swatch-row__pick')) {
      other.classList.toggle('ea-swatch-row__link--current', other === pick);
      other.setAttribute('aria-pressed', String(other === pick));
    }
    card.setAttribute('data-ea-picked', '');
  }, true);

  // Horizon shows the card's next photo while the mouse is over it. Its next photo belongs to the first colour or
  // length, so after a swatch click the card keeps the chosen photo instead. Horizon listens on the document
  // (assets/component.js), so this listener sits on the window, which the event reaches first.
  for (const type of ['pointerenter', 'pointerleave']) {
    window.addEventListener(
      type,
      (event) => {
        const target = event.target;
        if (target instanceof Element && target.matches('.card-gallery') && target.closest('product-card[data-ea-picked]')) {
          event.stopPropagation();
        }
      },
      true
    );
  }

  // The scent links carry role="button": the Space key works on them as on a button.
  document.addEventListener('keydown', (event) => {
    const pick = event.target instanceof Element ? event.target.closest('a.ea-swatch-row__pick') : null;
    if (!pick || event.key !== ' ') return;
    event.preventDefault();
    pick.click();
  });

  // Start loading a swatch's photo when the pointer reaches the swatch, so it is there by the click.
  document.addEventListener('pointerover', (event) => {
    const pick = event.target instanceof Element ? event.target.closest('.ea-swatch-row__pick') : null;
    const image = pick?.closest('product-card')?.querySelector(`slideshow-slide[slide-id="${pick.dataset.mediaId}"] img`);
    if (image) image.loading = 'eager';
  });
  } catch(e) { console.error(e); }
})();

})();
